import { useStaticQuery, graphql } from 'gatsby';
import { usePageContext } from 'gatsby-theme-thepuzzlers-core';

export const usePricingPageContent = () => {
  const { locale } = usePageContext();

  const data = useStaticQuery(graphql`
    query {
      en: pricingPageContentJson {
        header {
          description
          headline
          page_title {
            html
          }
          plus_description
          plus_get_list {
            text
          }
          plus_do_list {
            text
          }
          plus_price {
            html
          }
          plus_title
          starter_description
          starter_do_list {
            text
          }
          starter_get_list {
            text
          }
          starter_price {
            html
          }
          starter_title
          user_do_title
          user_get_title
        }
        packages {
          headline {
            html
          }
          packages {
            data {
              package_list {
                name
                plus
                starter
              }
              title
            }
          }
        }
      }
      de: dePricingPageContentJson {
        header {
          description
          headline
          page_title {
            html
          }
          plus_description
          plus_get_list {
            text
          }
          plus_do_list {
            text
          }
          plus_price {
            html
          }
          plus_title
          starter_description
          starter_do_list {
            text
          }
          starter_get_list {
            text
          }
          starter_price {
            html
          }
          starter_title
          user_do_title
          user_get_title
        }
        packages {
          headline {
            html
          }
          packages {
            data {
              package_list {
                name
                plus
                starter
              }
              title
            }
          }
        }
      }
    }
  `);

  return data[locale];
};
